import { CityUpdatePage } from "@/features/geolocation/page/CityUpdate";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/city/$id/update")({
  component: CityUpdatePage,
});
